import { Five9Client } from './client';

export default function LaunchSecurePayFlow(client = new Five9Client()){
  return client.getCampaigns().then((campaigns) => {
    const { data } = campaigns;
    const securePayCampaign = data.filter( d => d.name === "SecurePay" )[0];
    if(!!!securePayCampaign){
      return null;
    }
    const securePayCampaignId = securePayCampaign.id
    return client.fetchActiveCalls().then( (calls) => {
      const inboundCall = calls.data[0];
      if(!!!inboundCall){
        return undefined;
      }
      const inboundCallId = inboundCall.id;
      return client.transferToCampaign(inboundCallId, securePayCampaignId)
    });
  });
}
